import React from 'react';
import { CTAButton } from '../CTAButton';
import { painPoints } from '../../data/content';
export function PainPoints() {
  return <section className="w-full bg-white px-4 py-12 sm:py-16" data-id="element-217" data-mp="1twgvaqob8894">
      <div className="mx-auto max-w-4xl" data-id="element-218" data-mp="27mu5z0sl6125">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-navy-deep sm:text-4xl" data-id="element-219" data-mp="27nlnx8t9g09y">
          Do You Recognize Yourself in Any of These Situations?
        </h2>
        <p className="mt-3 text-center text-[15px] font-medium text-ink/70 sm:text-lg" data-id="element-220" data-mp="2hix3ftchtbir">
          If you answered “yes” to even one of them, this Kit was created for you.
        </p>

        <ul className="mt-8 grid gap-3.5 sm:grid-cols-2" data-id="element-221" data-mp="2qk52idmu2gdw">
          {painPoints.map(point => <li key={point.text} className="flex gap-3.5 rounded-2xl border border-navy/10 bg-cream p-4" data-id="element-222" data-mp="2mkmeh8zptp6u">
              <span aria-hidden="true" className="text-2xl leading-none" data-id="element-223" data-mp="w8ymxgyk985n">
                {point.emoji}
              </span>
              <p className="text-[14px] font-medium leading-snug text-ink/80" data-id="element-224" data-mp="1n8bqntla15w7">{point.text}</p>
            </li>)}
        </ul>

        <div className="mt-9 rounded-3xl bg-navy-deep p-6 text-center sm:p-8" data-id="element-225" data-mp="1s7oa04cxvuu1">
          <p className="font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-226" data-mp="1x4yaqg5s3sx6">The Good News?</p>
          <p className="mx-auto mt-3 max-w-xl text-[15px] font-medium leading-relaxed text-white/80 sm:text-base" data-id="element-227" data-mp="21wzm7zv4hfm5">
            You no longer need to memorize hundreds of pages of clinical guidelines. You simply need a
            Clinical Pathway designed to help you make better decisions from the very first
            consultation.
          </p>
          <div className="mx-auto mt-6 max-w-md" data-id="element-228" data-mp="2fuo3yytw86mz">
            <CTAButton label="I want to make safer decisions" data-id="element-229" data-mp="2kuiu305ugs6z" />
            <p className="mt-3 text-center text-[13px] font-medium text-white/60" data-id="element-230" data-mp="lig55aegb5lx">
              Instant Download · 7-Day Guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}